import { Autocomplete, CategorySearchConfig } from '../SearchBarProps';

export const getSubmitDataLinkEvent = (
	componentName: string,
	searchInput: string
): string => {
	return [
		componentName,
		'Search',
		'unified',
		'Input',
		'Submit Search',
		searchInput,
	].join('|');
};

export const getResultDataLinkEvent = (
	componentName: string,
	searchInput: string,
	result: Autocomplete
) => {
	const { category, label, id } = result;
	return [
		componentName,
		'Search',
		'unified',
		searchInput,
		'Result',
		'Search Result',
		category,
		label,
		id,
	].join('|');
};

export const getResultCategoryDataLinkEvent = (
	componentName: string,
	searchInput: string,
	catConfig: CategorySearchConfig
) => {
	return [
		componentName,
		'Search',
		'unified',
		searchInput,
		'Result',
		'Search Result',
		catConfig.label,
		'Category',
	].join('|');
};

export const getResultSummaryDataLinkEvent = (
	componentName: string,
	searchInput: string
) => {
	return [
		componentName,
		'Search',
		'unified',
		searchInput,
		'Result',
		'Search Result',
		'See All',
	].join('|');
};
